import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
import ActionButtons, { EditButton, DeleteButton } from '../../components/ActionButtons';
import { apiRequest } from '../../services/api';
import UsageInfo from '../../components/UsageInfo';
import { useKasa } from '../../context/KasaContext';
import LoadingSpinner from '../../components/LoadingSpinner';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';

function FormHata({ mesaj }) {
  if (!mesaj) return null;
  return <p className="text-[10px] font-black text-rose-500 uppercase tracking-widest mt-2 flex items-center gap-1 animate-shake">⚠️ {mesaj}</p>;
}

// ── Stok Giriş Modalı ──
function StokGirisModal({ stok, dovizKurlari, onKapat, onKaydet, kaydediliyor }) {
  const [miktar, setMiktar] = useState('');
  const [giderEkle, setGiderEkle] = useState(false);
  const [hatalar, setHatalar] = useState({});

  const pb = stok.paraBirimi || 'TRY';
  const yabanci = pb !== 'TL' && pb !== 'TRY';
  const kurDegeri = yabanci && dovizKurlari?.[pb] > 0 ? dovizKurlari[pb] : 1;
  const birimTry = stok.satisFiyat * kurDegeri;

  const handleKaydet = () => {
    if (!miktar || isNaN(miktar) || parseInt(miktar) <= 0) { setHatalar({ miktar: 'Geçerli bir miktar giriniz.' }); return; }
    onKaydet({ stokId: stok.stokId, miktar: parseInt(miktar), gidereEkle: giderEkle, kurDegeri });
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center p-0 lg:p-4 backdrop-blur-md animate-fade-in shadow-2xl leading-none">
      <div className="bg-white w-full max-w-md rounded-none lg:rounded-[2.5rem] shadow-2xl flex flex-col overflow-hidden border border-white/20 animate-scale-in">
        <div className="relative flex items-center justify-between px-8 py-7 bg-gradient-to-r from-emerald-600 to-teal-700 overflow-hidden text-white leading-none">
          <div className="absolute top-0 right-0 -mr-12 -mt-12 w-48 h-48 bg-white/10 rounded-full blur-2xl pointer-events-none transform-gpu"></div>
          <div className="relative flex items-center gap-4 leading-none text-left">
            <div className="w-12 h-12 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center text-2xl shadow-inner border border-white/30 font-black">📥</div>
            <div>
              <h2 className="font-black text-lg tracking-tight uppercase leading-none">Stok Girişi</h2>
              <p className="text-white/70 text-[10px] font-bold uppercase tracking-widest mt-1.5 opacity-80 leading-none">{stok.ad}</p>
            </div>
          </div>
          <button onClick={onKapat} className="relative z-10 text-white/60 hover:text-white w-10 h-10 flex items-center justify-center rounded-xl hover:bg-white/10 transition-all text-xl">✕</button>
        </div>

        <div className="flex-1 overflow-y-auto px-8 py-8 space-y-7 no-scrollbar text-left leading-none">
           <div className="bg-emerald-50 rounded-2xl p-5 border border-emerald-100 flex items-center justify-between leading-none shadow-inner">
              <span className="text-[10px] font-black text-emerald-600 uppercase tracking-widest">MEVCUT STOK</span>
              <span className="font-black text-emerald-700 text-xl tracking-tight">{stok.kalan} ADET</span>
           </div>

           <div>
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">EKLENECEK MİKTAR</label>
              <div className="relative">
                 <input type="number" value={miktar} onChange={e => { setMiktar(e.target.value); setHatalar({}); }} className={`w-full border-2 rounded-2xl px-6 pr-20 py-5 text-3xl font-black text-gray-900 focus:outline-none transition-all bg-white text-center sm:text-right ${hatalar.miktar ? 'border-rose-400 bg-rose-50' : 'border-gray-100 focus:border-emerald-400 shadow-sm'}`} placeholder="0" autoFocus />
                 <span className="absolute right-6 top-1/2 -translate-y-1/2 font-black text-gray-300 text-sm pointer-events-none uppercase tracking-widest">ADET</span>
              </div>
              <FormHata mesaj={hatalar.miktar} />
           </div>

           <button onClick={() => setGiderEkle(!giderEkle)} className={`w-full p-5 rounded-[1.8rem] border-2 transition-all duration-300 text-left flex items-center gap-4 transform-gpu select-none ${giderEkle ? 'border-emerald-500 bg-emerald-50 shadow-xl shadow-emerald-50' : 'border-gray-50 bg-gray-50/50 grayscale hover:grayscale-0'}`}>
              <div className={`w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-all ${giderEkle ? 'bg-emerald-600 border-emerald-600' : 'bg-white border-gray-200'}`}>
                 {giderEkle && <span className="text-white text-xs font-black leading-none">✓</span>}
              </div>
              <div className="flex-1 min-w-0">
                 <p className="text-[11px] font-black text-gray-800 uppercase tracking-widest mb-1 leading-none">GİDERLERE İŞLE</p>
                 <p className="text-[9px] font-bold text-gray-400 uppercase tracking-tight leading-none italic capitalize tracking-wide">OTOMATİK KASA ÇIKIŞI OLUŞTURUR</p>
              </div>
              {giderEkle && miktar > 0 && (
                <div className="text-right border-l-2 border-emerald-100 pl-4 leading-none">
                   <p className="text-[9px] font-black text-emerald-400 mb-1 leading-none">TOPLAM</p>
                   <p className="font-black text-emerald-700 text-lg leading-none">
                     {(parseInt(miktar) * stok.satisFiyat).toLocaleString('tr-TR')} {pb}
                   </p>
                   {yabanci && (
                     <p className="text-[9px] font-bold text-emerald-500 mt-0.5 leading-none">
                       ≈ {(parseInt(miktar) * birimTry).toLocaleString('tr-TR', { maximumFractionDigits: 0 })} ₺
                     </p>
                   )}
                </div>
              )}
           </button>
        </div>

        <div className="px-8 py-6 flex gap-4 justify-end border-t border-gray-50 bg-gray-50/50 leading-none">
          <button onClick={onKapat} className="px-8 py-3.5 rounded-2xl border-2 border-gray-100 text-xs font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95 leading-none">İPTAL</button>
          <button onClick={handleKaydet} disabled={kaydediliyor}
            className="px-10 py-3.5 bg-gradient-to-r from-emerald-600 to-teal-700 hover:from-emerald-700 hover:to-teal-800 disabled:opacity-60 text-white rounded-2xl text-xs font-black shadow-xl shadow-emerald-100 transition-all hover:-translate-y-1 active:translate-y-0 tracking-widest uppercase leading-none">
            {kaydediliyor ? '⌛ İŞLEM...' : '📥 STOK GİRİŞİ YAP'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Stok Form (Ekle/Düzenle) ──
function StokForm({ stok, gruplar, paraBirimleri, onKaydet, onGeri, onGruplariAc, kaydediliyor }) {
  const yeni = !stok;
  const [form, setForm] = useState(stok ? { ...stok, stokGrubuId: stok.stokGrubuId || '' } : { ad: '', stokGrubuId: '', satisFiyat: 0, paraBirimi: 'TL', kalan: 0, siraNo: 1, resimYolu: '', aktifMi: true });
  const [hatalar, setHatalar] = useState({});
  const [resimYukleniyor, setResimYukleniyor] = useState(false);
  const resimInputRef = useRef(null);
  const API_URL    = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const STATIC_BASE = API_URL.replace(/\/api\/?$/, '');

  // Yeni ürün eklerken default para birimini TRY'ye çek
  useEffect(() => {
    if (yeni && paraBirimleri.length > 0) {
      const tryPb = paraBirimleri.find(p => p.tcmbKod === 'TRY' || p.tcmbKod === 'TL');
      if (tryPb) setForm(p => ({ ...p, paraBirimi: tryPb.tcmbKod }));
    }
  }, [paraBirimleri]); // eslint-disable-line react-hooks/exhaustive-deps

  const set = (k, v) => { setForm(p => ({ ...p, [k]: v })); setHatalar(p => ({ ...p, [k]: null })); };
  const INP = (h) => `w-full border-2 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 transition-all bg-white focus:outline-none ${h ? 'border-rose-400 bg-rose-50' : 'border-gray-100 focus:border-emerald-400 shadow-sm'}`;

  const handleResimSec = async (e) => {
    const dosya = e.target.files?.[0];
    if (!dosya || !stok?.stokId) return;
    setResimYukleniyor(true);
    try {
      const formData = new FormData();
      formData.append('dosya', dosya);
      const res = await fetch(`${API_URL}/stok/${stok.stokId}/resim`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });
      if (!res.ok) { const err = await res.json().catch(() => ({})); alert(err.message || 'Yükleme başarısız.'); return; }
      const data = await res.json();
      setForm(p => ({ ...p, resimYolu: data.url }));
    } catch { alert('Yükleme başarısız.'); }
    finally { setResimYukleniyor(false); e.target.value = ''; }
  };

  const handleKaydet = () => {
    if (!form.ad.trim()) { setHatalar({ ad: 'Ürün adı zorunludur.' }); return; }
    if (!form.stokGrubuId) { setHatalar({ stokGrubuId: 'Grup seçimi zorunludur.' }); return; }
    onKaydet(form);
  };

  return (
    <div className="space-y-6 max-w-4xl mx-auto animate-slide-up leading-none text-left">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-6">
           <button onClick={onGeri} className="w-12 h-12 bg-white rounded-2xl border-2 border-gray-100 flex items-center justify-center text-gray-400 hover:bg-gray-50 hover:text-emerald-600 transition-all shadow-sm transform-gpu active:scale-90">←</button>
           <div>
              <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest leading-none mb-2">STOK / ÜRÜN TANIMI</p>
              <h2 className="text-2xl font-black text-gray-900 tracking-tight leading-none uppercase">{yeni ? 'Yeni Ürün Kaydı' : `"${form.ad}" Güncelle`}</h2>
           </div>
        </div>
      </div>

      <div className="bg-white rounded-[2.5rem] border border-gray-100 shadow-xl overflow-hidden leading-none">
        <div className="p-8 md:p-12 space-y-10 leading-none">
           <div className="grid grid-cols-1 md:grid-cols-2 gap-10 leading-none text-left">
              <div className="space-y-8 leading-none">
                 <div>
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">ÜRÜN GÖRSELİ</label>
                    <div className="flex items-center gap-6">
                       <div className="w-28 h-28 bg-gray-50 rounded-[2.5rem] border-4 border-white shadow-xl shadow-gray-100 flex items-center justify-center text-5xl transform-gpu hover:scale-105 transition-transform duration-500 ring-8 ring-gray-50 overflow-hidden">
                         {form.resimYolu
                           ? <img src={`${STATIC_BASE}${form.resimYolu}`} alt="" className="w-full h-full object-cover" />
                           : '📦'}
                       </div>
                       <div className="space-y-2">
                          <input ref={resimInputRef} type="file" accept=".jpg,.jpeg,.png,.gif,.webp" className="hidden" onChange={handleResimSec} />
                          {yeni ? (
                            <p className="text-[9px] font-bold text-gray-400 uppercase leading-relaxed tracking-wider italic">Resim yüklemek için önce kaydediniz.</p>
                          ) : (
                            <>
                              <button onClick={() => resimInputRef.current?.click()} disabled={resimYukleniyor}
                                className="px-5 py-2.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-600 text-[10px] font-black rounded-xl border border-indigo-100 transition-all uppercase tracking-widest disabled:opacity-50">
                                {resimYukleniyor ? '⏳ YÜKLENİYOR...' : 'RESİM YÜKLE'}
                              </button>
                              <p className="text-[9px] font-bold text-gray-400 uppercase leading-relaxed tracking-wider italic">ÖNERİLEN BOYUT: 512x512 PX</p>
                            </>
                          )}
                       </div>
                    </div>
                 </div>

                 <div className="text-left leading-none">
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">ÜRÜN ADI *</label>
                    <input value={form.ad} onChange={e => {
                      const v = e.target.value;
                      const formatted = v.toLocaleLowerCase('tr-TR').split(' ').map(s => s.charAt(0).toLocaleUpperCase('tr-TR') + s.slice(1)).join(' ');
                      set('ad', formatted);
                    }} className={INP(hatalar.ad)} placeholder="Örn: Coca Cola 330ml" />
                    <FormHata mesaj={hatalar.ad} />
                 </div>

                 <div className="text-left leading-none">
                    <div className="flex items-center justify-between mb-3 leading-none">
                       <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] ml-1">STOK GRUBU *</label>
                       <button onClick={onGruplariAc} className="text-[9px] font-black text-emerald-600 hover:text-emerald-800 uppercase tracking-widest bg-emerald-50 px-2 py-0.5 rounded-lg border border-emerald-100 italic">GRUPLARI YÖNET</button>
                    </div>
                    <select value={form.stokGrubuId} onChange={e => set('stokGrubuId', e.target.value ? parseInt(e.target.value) : '')} className={INP(hatalar.stokGrubuId) + ' cursor-pointer uppercase'}>
                       <option value="">— GRUP SEÇİNİZ —</option>
                       {gruplar.map(g => <option key={g.stokGrubuId} value={g.stokGrubuId}>{g.ad}</option>)}
                    </select>
                    <FormHata mesaj={hatalar.stokGrubuId} />
                 </div>
              </div>

              <div className="space-y-8 leading-none">
                 <div className="grid grid-cols-2 gap-6 leading-none">
                    <div>
                       <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">SATIŞ FİYATI</label>
                       <div className="relative">
                          <input type="number" step="0.01" value={form.satisFiyat} onChange={e => set('satisFiyat', parseFloat(e.target.value) || 0)} className={INP(false) + ' text-center text-lg'} />
                          <span className="absolute right-5 top-1/2 -translate-y-1/2 font-black text-gray-300 text-sm">₺</span>
                       </div>
                    </div>
                    <div>
                       <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">PARA BİRİMİ</label>
                       <select value={form.paraBirimi} onChange={e => set('paraBirimi', e.target.value)} className={INP(false) + ' uppercase cursor-pointer'}>
                          {(paraBirimleri.length > 0 ? paraBirimleri.map(p => p.tcmbKod) : ['TL', 'USD', 'EUR']).map(p => <option key={p} value={p}>{p}</option>)}
                       </select>
                    </div>
                 </div>

                 <div className="grid grid-cols-2 gap-6 leading-none">
                    <div>
                       <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">MEVCUT STOK</label>
                       <input type="number" value={form.kalan} onChange={e => set('kalan', parseInt(e.target.value) || 0)} className={INP(false) + ' text-center text-lg'} />
                    </div>
                    <div>
                       <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">SIRA NO</label>
                       <input type="number" min="1" value={form.siraNo} onChange={e => set('siraNo', parseInt(e.target.value) || 1)} className={INP(false) + ' text-center text-lg'} />
                    </div>
                 </div>

                 <div className="pt-6 border-t border-gray-50 leading-none">
                    <label className="flex items-center justify-between bg-gray-50/50 p-5 rounded-3xl border-2 border-gray-100 shadow-inner group select-none cursor-pointer leading-none">
                       <div className="leading-none text-left">
                          <span className={`text-[10px] font-black uppercase tracking-widest block mb-1 transition-colors ${form.aktifMi ? 'text-emerald-600' : 'text-gray-400'}`}>ÜRÜN SATIŞA AÇIK (AKTİF)</span>
                          <p className="text-[9px] font-bold text-gray-400 uppercase leading-none opacity-60">SADECE AKTİF ÜRÜNLER SATIŞ EKRANINA GELİR</p>
                       </div>
                       <div className="relative">
                         <input type="checkbox" checked={form.aktifMi} onChange={e => set('aktifMi', e.target.checked)} className="sr-only peer" />
                         <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-7 peer-checked:after:border-white after:content-[''] after:absolute after:top-[4px] after:left-[4px] after:bg-white after:border-gray-200 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500 shadow-sm transform-gpu"></div>
                       </div>
                    </label>
                 </div>
              </div>
           </div>
        </div>

        <div className="px-8 py-6 bg-gray-50/50 border-t border-gray-100 flex items-center justify-between leading-none">
           <button onClick={onGeri} className="px-8 py-4 bg-white border-2 border-gray-100 rounded-2xl text-[10px] font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95 leading-none shadow-sm transform-gpu">VAZGEÇ / İPTAL</button>
           <button onClick={handleKaydet} disabled={kaydediliyor} 
             className="px-12 py-4 bg-gradient-to-r from-emerald-600 to-teal-700 hover:from-emerald-700 hover:to-teal-800 text-white rounded-2xl text-[10px] font-black shadow-2xl shadow-emerald-100 transition-all hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest leading-none transform-gpu">
             {kaydediliyor ? '⌛ İŞLENİYOR...' : '💾 ÜRÜN BİLGİLERİNİ KAYDET'}
           </button>
        </div>
      </div>
    </div>
  );
}

// ── Stok Grupları ──
function StokGruplari({ gruplar, onGrupEkle, onGrupGuncelle, onGrupSil, onGeri, kaydediliyor }) {
  const [duzenle, setDuzenle] = useState(null);
  const [form, setForm] = useState({ ad: '', siraNo: 1 });
  const [hata, setHata] = useState(null);

  const handleKaydet = async () => {
    if (!form.ad.trim()) return;
    setHata(null);
    try {
      const formattedAd = form.ad.toLocaleLowerCase('tr-TR').split(' ').map(s => s.charAt(0).toLocaleUpperCase('tr-TR') + s.slice(1)).join(' ');
      if (duzenle === 'yeni') await onGrupEkle({ ad: formattedAd, siraNo: form.siraNo });
      else await onGrupGuncelle({ ...duzenle, ad: formattedAd, siraNo: form.siraNo });
      setDuzenle(null); setForm({ ad: '', siraNo: 1 });
    } catch { setHata('Hata oluştu.'); }
  };

  return (
    <div className="space-y-7 max-w-4xl mx-auto animate-slide-up leading-none text-left">
      <div className="flex items-center justify-between gap-4 leading-none">
        <div className="flex items-center gap-6 leading-none">
           <button onClick={onGeri} className="w-12 h-12 bg-white rounded-2xl border-2 border-gray-100 flex items-center justify-center text-gray-400 hover:bg-gray-50 hover:text-indigo-600 transition-all shadow-sm transform-gpu active:scale-90">←</button>
           <div className="leading-none">
              <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest leading-none mb-2 text-left">STOK / KATEGORİ</p>
              <h2 className="text-2xl font-black text-gray-900 tracking-tight leading-none uppercase text-left">Grup Yönetimi</h2>
           </div>
        </div>
        <button onClick={() => { setDuzenle('yeni'); setForm({ ad: '', siraNo: gruplar.length + 1 }); }}
          className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-4 rounded-2xl text-[10px] font-black shadow-2xl shadow-indigo-100 transition-all hover:-translate-y-1 uppercase tracking-widest leading-none transform-gpu">
          ＋ YENİ GRUP EKLE
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start leading-none">
         <div className="md:col-span-8 bg-white rounded-[2.5rem] border border-gray-100 shadow-xl overflow-hidden leading-none">
            <div className="px-8 py-5 border-b border-gray-100 bg-gray-50/20 text-[10px] font-black text-gray-400 uppercase tracking-widest leading-none text-left">MEVCUT STOK GRUPLARI ({gruplar.length})</div>
            <div className="overflow-x-auto leading-none text-left">
               <table className="w-full text-sm leading-none">
                  <thead>
                     <tr className="bg-gray-50/30 text-[10px] font-black text-gray-400 border-b border-gray-100 font-sans uppercase tracking-[0.2em]">
                        <th className="py-4 px-8 text-left w-20 leading-none">#</th>
                        <th className="py-4 px-8 text-left leading-none">GRUP ADI</th>
                        <th className="py-4 px-8 text-center w-24 leading-none">SIRA</th>
                        <th className="py-4 px-8 text-right leading-none">İŞLEM</th>
                     </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50 leading-none font-sans">
                     {gruplar.map((g, i) => (
                       <tr key={g.stokGrubuId} className="group hover:bg-indigo-50/20 transition-all transform-gpu leading-none">
                          <td className="py-4 px-8 font-black text-gray-300 text-xs leading-none">{(i+1).toString().padStart(2,'0')}</td>
                          <td className="py-4 px-8 font-black text-gray-700 leading-none uppercase">{g.ad}</td>
                          <td className="py-4 px-8 text-center leading-none"><span className="text-[10px] font-black bg-gray-100 px-3 py-1 rounded-lg leading-none">{g.siraNo}</span></td>
                          <td className="py-4 px-8 text-right leading-none">
                             <ActionButtons onEdit={() => { setDuzenle(g); setForm({ ad: g.ad, siraNo: g.siraNo }); }} onDelete={() => onGrupSil(g.stokGrubuId)} />
                          </td>
                       </tr>
                     ))}
                  </tbody>
               </table>
            </div>
         </div>

         {duzenle && (
           <div className="md:col-span-4 bg-white rounded-[2.5rem] border border-gray-100 shadow-xl p-8 space-y-6 animate-scale-in leading-none text-left">
              <h3 className="text-base font-black text-gray-800 uppercase tracking-tight leading-none text-left">{duzenle === 'yeni' ? 'GRUP EKLE' : 'GRUP DÜZENLE'}</h3>
              {hata && <div className="text-[10px] font-black text-rose-500 uppercase italic animate-shake leading-none text-left px-1">{hata}</div>}
              <div className="space-y-5 leading-none">
                 <div className="text-left leading-none">
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-3 ml-1">KATEGORİ ADI</label>
                    <input value={form.ad} onChange={e => setForm(p => ({ ...p, ad: e.target.value }))} className="w-full border-2 border-gray-100 rounded-2xl px-5 py-4 text-sm font-black focus:border-indigo-400 focus:outline-none transition-all leading-none" placeholder="ÖRN: Meşrubatlar" autoFocus />
                 </div>
                 <div className="text-left leading-none">
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-3 ml-1">SIRA NO</label>
                    <input type="number" value={form.siraNo} onChange={e => setForm(p => ({ ...p, siraNo: parseInt(e.target.value) || 0 }))} className="w-full border-2 border-gray-100 rounded-2xl px-5 py-4 text-sm font-black focus:border-indigo-400 focus:outline-none transition-all text-center leading-none" />
                 </div>
                 <div className="flex gap-3 leading-none pt-2">
                    <button onClick={() => setDuzenle(null)} className="flex-1 py-4 bg-gray-50 text-gray-400 rounded-2xl text-[10px] font-black hover:bg-gray-100 transition-all uppercase leading-none transform-gpu active:scale-95">Vazgeç</button>
                    <button onClick={handleKaydet} disabled={kaydediliyor} className="flex-[2] py-4 bg-indigo-600 text-white rounded-2xl text-[10px] font-black shadow-xl shadow-indigo-100 hover:bg-indigo-700 transition-all uppercase tracking-widest leading-none transform-gpu active:scale-95">Kaydet</button>
                 </div>
              </div>
           </div>
         )}
      </div>
    </div>
  );
}

// ── StokUrun Ana Komponent ──
export default function StokUrun() {
  const { dovizKurlari } = useKasa();
  const [stoklar, setStoklar] = useState([]);
  const [gruplar, setGruplar] = useState([]);
  const [paraBirimleri, setParaBirimleri] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [view, setView] = useState('liste');
  const [seciliStok, setSeciliStok] = useState(null);
  const [stokGirisModal, setStokGirisModal] = useState(null);
  const [silOnay, setSilOnay] = useState(null);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [aramaMetni, setAramaMetni] = useState('');
  const [grupFiltre, setGrupFiltre] = useState('');

  const veriYukle = useCallback(async () => {
    setYukleniyor(true);
    try {
      const [s, g, p] = await Promise.all([apiRequest('stok'), apiRequest('stokgrubu/gruplar'), apiRequest('ParaBirimi')]);
      setStoklar(s || []); setGruplar(g || []); setParaBirimleri(p || []);
    } catch { /* sessiz */ }
    setYukleniyor(false);
  }, []);

  useEffect(() => { veriYukle(); }, [veriYukle]);

  const stokKaydet = async (form) => {
    setKaydediliyor(true);
    try {
      if (form.stokId) await apiRequest('stok', 'PUT', form);
      else await apiRequest('stok', 'POST', form);
      await veriYukle(); setView('liste'); setSeciliStok(null);
    } catch { alert('Kayıt başarısız.'); }
    setKaydediliyor(false);
  };

  const stokGirisKaydet = async (dto) => {
    setKaydediliyor(true);
    try { await apiRequest('stok/giris', 'POST', dto); await veriYukle(); setStokGirisModal(null); } catch { alert('Giriş başarısız.'); }
    setKaydediliyor(false);
  };

  const stokSil = async (id) => { await apiRequest(`stok/${id}`, 'DELETE'); await veriYukle(); setSilOnay(null); };

  const grupEkle = async (form) => { await apiRequest('stokgrubu/gruplar', 'POST', form); await veriYukle(); };
  const grupGuncelle = async (form) => { await apiRequest('stokgrubu/gruplar', 'PUT', form); await veriYukle(); };
  const grupSil = async (id) => { await apiRequest(`stokgrubu/gruplar/${id}`, 'DELETE'); await veriYukle(); };

  const filtreli = useMemo(() => stoklar.filter(s => {
    const a = (s.ad?.toLocaleLowerCase('tr-TR') || '').includes(aramaMetni.toLocaleLowerCase('tr-TR')) || (s.stokGrubuAd?.toLocaleLowerCase('tr-TR') || '').includes(aramaMetni.toLocaleLowerCase('tr-TR'));
    const g = grupFiltre === '' || s.stokGrubuId === parseInt(grupFiltre);
    return a && g;
  }), [stoklar, aramaMetni, grupFiltre]);

  const stats = useMemo(() => ([
    { label: 'ÜRÜN ÇEŞİDİ', value: stoklar.length, icon: '📦', color: 'from-gray-700 to-gray-900 shadow-gray-200' },
    { label: 'KRİTİK STOK', value: stoklar.filter(s => s.kalan <= 0).length, icon: '⚠️', color: stoklar.filter(s => s.kalan <= 0).length > 0 ? 'from-rose-500 to-red-700 shadow-rose-100' : 'from-emerald-500 to-emerald-700 shadow-emerald-100' },
    { label: 'TOPLAM GRUP', value: gruplar.length, icon: '📂', color: 'from-indigo-600 to-blue-700 shadow-blue-100' },
    { label: 'PASİF ÜRÜN', value: stoklar.filter(s => !s.aktifMi).length, icon: '⏸', color: 'from-amber-400 to-orange-500 shadow-amber-100' },
  ]), [stoklar, gruplar]);

  if (view === 'gruplar') return <div className="p-3 md:p-6 bg-gray-50/50 min-h-screen font-sans"><StokGruplari gruplar={gruplar} onGrupEkle={grupEkle} onGrupGuncelle={grupGuncelle} onGrupSil={grupSil} onGeri={() => setView('liste')} kaydediliyor={kaydediliyor} /></div>;
  if (view === 'ekle' || view === 'duzenle') return <div className="p-3 md:p-6 bg-gray-50/50 min-h-screen font-sans"><StokForm stok={seciliStok} gruplar={gruplar} paraBirimleri={paraBirimleri} onKaydet={stokKaydet} onGeri={() => setView('liste')} onGruplariAc={() => setView('gruplar')} kaydediliyor={kaydediliyor} /></div>;

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50 animate-fadeIn text-left leading-none font-sans" style={{ transform: 'translateZ(0)' }}>
      <PageHeader
        icon="📦"
        iconColor="from-emerald-600 to-teal-700"
        iconShadow="shadow-emerald-200"
        title="Envanter & Stok"
        subtitle="Ürün kataloğu ve stok girişi yönetimi"
      >
        <div className="flex flex-wrap lg:flex-nowrap items-center gap-4 leading-none">
          <button onClick={() => setView('gruplar')} className="px-8 py-4 bg-white border-2 border-gray-100 rounded-2xl text-[10px] font-black text-gray-500 hover:text-indigo-600 hover:border-indigo-100 transition-all uppercase tracking-widest leading-none shadow-sm transform-gpu active:scale-95">📂 GRUP YÖNETİMİ</button>
          <button onClick={() => { setSeciliStok(null); setView('ekle'); }}
            className="group flex-shrink-0 flex items-center justify-center gap-4 bg-gradient-to-r from-emerald-600 to-teal-700 hover:from-emerald-700 hover:to-teal-800 text-white px-10 py-4 rounded-2xl text-[10px] font-black shadow-2xl shadow-emerald-100 transition-all hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest relative overflow-hidden leading-none transform-gpu">
            <span className="absolute inset-0 bg-white/10 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
            <span className="relative text-xl leading-none">＋</span> <span className="relative leading-none">YENİ ÜRÜN TANIMLA</span>
          </button>
        </div>
      </PageHeader>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 leading-none transform-gpu">
        {stats.map(k => (
          <div key={k.label} className={`relative overflow-hidden bg-gradient-to-br ${k.color} rounded-[2rem] p-6 text-white shadow-xl hover:shadow-2xl transition-all duration-300 group leading-none`}>
            <div className="absolute -right-4 -bottom-4 text-7xl opacity-10 pointer-events-none group-hover:scale-125 transition-transform duration-500 transform-gpu leading-none">{k.icon}</div>
            <p className="text-[10px] font-black uppercase tracking-widest opacity-70 mb-1 leading-none text-left">{k.label}</p>
            <p className="text-xl md:text-2xl font-black tracking-tight leading-none text-left">{k.value}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-[2.5rem] border border-gray-100 shadow-xl overflow-hidden min-h-[400px] leading-none transform-gpu transition-shadow duration-500 hover:shadow-2xl hover:shadow-emerald-100/30">
        <div className="px-6 md:px-10 py-6 border-b-2 border-gray-100 bg-gray-50/20 flex flex-col xl:flex-row xl:items-center gap-6 leading-none">
          <div className="relative flex-1 w-full text-left leading-none">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-black leading-none">🔍</span>
            <input value={aramaMetni} onChange={e => setAramaMetni(e.target.value)} placeholder="ÜRÜN ADI VEYA GRUP ARA..."
              className="w-full pl-11 pr-4 py-3.5 text-sm border-2 border-gray-100 rounded-2xl focus:border-emerald-400 focus:outline-none bg-white transition-all shadow-inner font-bold leading-none shadow-emerald-50" />
          </div>
          <div className="flex items-center gap-4 leading-none w-full xl:w-auto">
             <div className="relative flex-1 min-w-[200px]">
                <select value={grupFiltre} onChange={e => setGrupFiltre(e.target.value)} className="w-full px-6 py-3.5 border-2 border-gray-100 rounded-2xl text-[10px] font-black uppercase tracking-widest focus:outline-none focus:border-emerald-400 leading-none bg-white cursor-pointer appearance-none">
                   <option value="">TÜM KATEGORİLER</option>
                   {gruplar.map(g => <option key={g.stokGrubuId} value={g.stokGrubuId}>{g.ad}</option>)}
                </select>
                <span className="absolute right-6 top-1/2 -translate-y-1/2 text-gray-400 font-black text-xs pointer-events-none">▼</span>
             </div>
             <button onClick={() => { setAramaMetni(''); setGrupFiltre(''); }} className="px-6 py-3.5 text-rose-500 font-black text-[10px] uppercase tracking-widest hover:bg-rose-50 rounded-2xl transition-all leading-none">SIFIRLA</button>
          </div>
        </div>

        {yukleniyor ? (
          <LoadingSpinner fullPage text="Envanter Sayımı Yapılıyor..." />
        ) : (
          <>
            {/* Mobile Cards */}
            <div className="md:hidden divide-y divide-gray-50 leading-none">
               {filtreli.length === 0 ? (
                 <EmptyState icon="📦" text="Eşleşen sonuç bulunamadı" />
               ) : filtreli.map(s => (
                 <div key={s.stokId} className={`p-6 flex flex-col gap-6 hover:bg-emerald-50/20 transition-all transform-gpu group ${!s.aktifMi && 'grayscale-[0.5] opacity-60 bg-gray-50'} ${s.kalan <= 0 ? 'bg-rose-50/30' : ''}`}>
                    <div className="flex items-center justify-between gap-4 leading-none text-left">
                       <div className="flex items-center gap-5 leading-none text-left">
                          <div className="w-16 h-16 bg-white rounded-2xl shadow-xl shadow-gray-100 border-2 border-gray-50 flex items-center justify-center text-3xl transform-gpu group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 leading-none overflow-hidden">
                            {s.resimYolu ? <img src={`${(process.env.REACT_APP_API_URL || '').replace(/\/api\/?$/, '')}${s.resimYolu}`} alt="" className="w-full h-full object-cover" /> : '📦'}
                          </div>
                          <div className="leading-none text-left flex-1 min-w-0">
                             <h3 className="font-black text-gray-800 text-lg uppercase tracking-tight truncate leading-none mb-2">{s.ad}</h3>
                             <p className={`text-[10px] font-black uppercase tracking-widest leading-none mb-2 ${s.stokGrubuAd ? 'text-emerald-500 opacity-80' : 'text-rose-500 animate-pulse bg-rose-50 px-2 py-1 rounded-lg border border-rose-100 italic'}`}>
                                {s.stokGrubuAd || '⚠️ GRUP SEÇİLMELİ'}
                             </p>
                             <div className="flex items-center gap-3 leading-none">
                                <span className={`text-[9px] font-black px-2.5 py-1 rounded-lg border-2 uppercase tracking-widest ${s.kalan <= 0 ? 'bg-rose-50 text-rose-600 border-rose-100 animate-pulse' : 'bg-emerald-50 text-emerald-600 border-emerald-100'}`}>{s.kalan} ADET STOK</span>
                                {s.satisFiyat > 0 && <span className="text-[9px] font-black text-gray-400 uppercase tracking-widest leading-none">{s.satisFiyat} {s.paraBirimi}</span>}
                             </div>
                          </div>
                       </div>
                    </div>
                    <div className="flex gap-2 leading-none">
                       <button onClick={() => setStokGirisModal(s)} className="flex-[2] bg-emerald-600 hover:bg-emerald-700 text-white text-[10px] font-black py-4 rounded-2xl transition-all shadow-xl shadow-emerald-100 uppercase tracking-widest leading-none transform-gpu active:scale-95">📥 STOK GİRİŞİ</button>
                       <EditButton size="lg" onClick={() => { setSeciliStok(s); setView('duzenle'); }} />
                       <DeleteButton size="lg" onClick={() => setSilOnay(s.stokId)} />
                    </div>
                 </div>
               ))}
            </div>

            {/* Desktop Table View */}
            <div className="hidden md:block overflow-x-auto leading-none text-left">
              <table className="w-full text-sm leading-none text-left">
                <thead>
                  <tr className="bg-gray-50/50 text-[11px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-100 font-sans">
                    <th className="py-6 px-8 text-left w-20 leading-none">SIRA</th>
                    <th className="py-6 px-8 text-left leading-none">ÜRÜN DETAYI</th>
                    <th className="py-6 px-8 text-center w-40 leading-none">STOK MİKTARI</th>
                    <th className="py-6 px-8 text-center w-48 leading-none">KATEGORİ</th>
                    <th className="py-6 px-8 text-right leading-none">İŞLEMLER</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50 leading-none font-sans text-left">
                  {filtreli.map((s, i) => (
                    <tr key={s.stokId} className={`group transition-all duration-300 hover:bg-emerald-50/20 transform-gpu ${!s.aktifMi ? 'grayscale-[0.8] opacity-60 bg-gray-50/40' : ''}`}>
                      <td className="py-6 px-8 font-black text-gray-300 text-xs leading-none">{s.siraNo}</td>
                      <td className="py-6 px-8 text-left leading-none font-black text-gray-700 text-base uppercase tracking-tight">
                         <div className="flex items-center gap-5 leading-none text-left">
                            <div className="w-12 h-12 bg-white rounded-2xl shadow-xl shadow-gray-50 border-2 border-gray-50 flex items-center justify-center text-2xl group-hover:scale-110 transition-transform leading-none shadow-emerald-50/30 overflow-hidden">
                              {s.resimYolu ? <img src={`${(process.env.REACT_APP_API_URL || '').replace(/\/api\/?$/, '')}${s.resimYolu}`} alt="" className="w-full h-full object-cover" /> : '📦'}
                            </div>
                            <div className="leading-none text-left flex-1 min-w-0">
                               <span className="group-hover:text-emerald-600 transition-colors uppercase leading-none block mb-1 truncate">{s.ad}</span>
                               <span className="text-[10px] font-black text-gray-300 tracking-widest leading-none opacity-80 uppercase italic lowercase tracking-tight italic">BIRIM FIYAT: {s.satisFiyat} {s.paraBirimi}</span>
                            </div>
                         </div>
                      </td>
                      <td className="py-6 px-8 text-center leading-none">
                         <div className={`px-5 py-2.5 rounded-[1.8rem] border-2 transition-all duration-300 inline-block transform-gpu group-hover:scale-110 leading-none ${s.kalan <= 0 ? 'bg-rose-50 border-rose-100 text-rose-600 animate-pulse' : 'bg-white border-gray-100 text-gray-700 shadow-sm'}`}>
                            <span className="text-lg font-black leading-none">{s.kalan}</span>
                            <span className="text-[9px] font-black ml-2 uppercase opacity-50 tracking-widest leading-none">ADET</span>
                         </div>
                      </td>
                      <td className="py-6 px-8 text-center leading-none">
                         <span className={`text-[10px] font-black px-4 py-2 rounded-xl uppercase tracking-widest border shadow-sm inline-block transition-colors ${s.stokGrubuAd ? 'text-emerald-600 bg-emerald-50 border-emerald-100 group-hover:bg-emerald-100' : 'text-rose-600 bg-rose-50 border-rose-100 animate-pulse italic'}`}>
                            {s.stokGrubuAd || '⚠️ GRUP SEÇİLMELİ'}
                         </span>
                      </td>
                      <td className="py-6 px-8 text-right leading-none">
                        <div className="flex items-center justify-end gap-3 leading-none">
                          <button onClick={() => setStokGirisModal(s)} className="h-11 px-5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-2xl text-[10px] font-black shadow-xl shadow-emerald-100 uppercase transition-all hover:-translate-y-1 active:translate-y-0 leading-none">📥 STOK GİRİŞİ</button>
                          <ActionButtons onEdit={() => { setSeciliStok(s); setView('duzenle'); }} onDelete={() => setSilOnay(s.stokId)} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      <UsageInfo
        color="teal"
        description="Stok ve Envanter modülü, otel içinde satışa sunulan ekstraları (Minibar, Snack vb.) ve teknik sarf malzemelerini takip etmenizi sağlar."
        scenarios={[
          { title: "Hızlı Stok Girişi", content: "Yeni ürün alımı yaptığınızda tek tıkla miktar güncellemesi yapabilir, dilerseniz bu alımı otomatik olarak kasa giderine işleyebilirsiniz." },
          { title: "Kategori Bazlı Takip", content: "Ürünleri 'İçecek', 'Gıda' veya 'Sarf Malzeme' olarak gruplandırarak departman bazlı envanter değerlerinizi görebilirsiniz." },
          { title: "Kritik Stok Uyarısı", content: "Kalan miktarı sıfıra düşen ürünler listede kırmızı ve animasyonlu olarak ön plana çıkarılarak tedarik sürecini tetikler." }
        ]}
      />

      {stokGirisModal && createPortal(
        <StokGirisModal stok={stokGirisModal} dovizKurlari={dovizKurlari} onKapat={() => setStokGirisModal(null)} onKaydet={stokGirisKaydet} kaydediliyor={kaydediliyor} />,
        document.body
      )}

      {silOnay && createPortal(
        <div className="fixed inset-0 bg-black/60 z-[110] flex items-center justify-center p-4 backdrop-blur-md animate-fade-in shadow-2xl leading-none font-black uppercase text-center">
          <div className="bg-white rounded-[2.5rem] shadow-2xl p-10 w-full max-w-sm border border-gray-100 leading-none">
            <div className="w-24 h-24 bg-rose-50 rounded-[2.5rem] flex items-center justify-center mx-auto mb-6 text-5xl shadow-xl shadow-rose-100/50 animate-bounce-subtle leading-none">🗑️</div>
            <h3 className="font-black text-gray-900 text-xl tracking-tight leading-none uppercase">Ürünü Sil</h3>
            <p className="text-[11px] font-black text-gray-400 mt-5 mb-10 leading-relaxed uppercase tracking-tight leading-loose italic">BU ÜRÜN ENVANTERDEN KALICI OLARAK SİLİNECEKTİR. EMİN MİSİNİZ?</p>
            <div className="flex gap-4">
              <button onClick={() => setSilOnay(null)} className="flex-1 py-4 bg-gray-50 text-gray-600 rounded-2xl text-[10px] font-black hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95 leading-none">İPTAL</button>
              <button onClick={() => stokSil(silOnay)} className="flex-1 py-4 bg-gradient-to-r from-rose-500 to-red-600 text-white rounded-2xl text-[10px] font-black shadow-xl shadow-rose-100 transition-all uppercase tracking-widest transform-gpu active:scale-95 leading-none font-black text-lg">EVET, SİL</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scaleIn 0.3s ease-out forwards; }
        @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
        .animate-shake { animation: shake 0.3s ease-in-out infinite; animation-iteration-count: 2; }
        @keyframes slideUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        .animate-slide-up { animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
        @keyframes bounceSubtle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        .animate-bounce-subtle { animation: bounceSubtle 2s infinite; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}